function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      whiteSpace: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M 5.8242188 2 A 0.50005 0.50005 0 0 0 5.7734375 2.0019531 A 0.50005 0.50005 0 0 0 5.5605469 2.9375 L 6.1074219 3.2539062 C 4.7673086 3.7070177 3.7187229 4.7652638 3.2792969 6.1113281 L 2.9375 5.5195312 A 0.50005 0.50005 0 0 0 2.4804688 5.2636719 A 0.50005 0.50005 0 0 0 2.0703125 6.0195312 L 3.0703125 7.75 A 0.50005 0.50005 0 0 0 3.5292969 8 A 0.50005 0.50005 0 0 0 3.546875 8 A 0.50005 0.50005 0 0 0 3.8886719 7.8554688 L 5.4863281 6.9335938 A 0.50005 0.50005 0 1 0 4.9863281 6.0683594 L 4.1894531 6.5292969 C 4.5221463 5.3672252 5.4315298 4.4663059 6.5976562 4.1425781 L 6.109375 4.9863281 A 0.50050329 0.50050329 0 1 0 6.9765625 5.4863281 L 7.9765625 3.7539062 A 0.50005 0.50005 0 0 0 8.0292969 3.3925781 A 0.50005 0.50005 0 0 0 8.0234375 3.3671875 A 0.50005 0.50005 0 0 0 7.9980469 3.296875 A 0.50005 0.50005 0 0 0 7.9863281 3.2734375 A 0.50005 0.50005 0 0 0 7.9746094 3.2519531 A 0.50005 0.50005 0 0 0 7.7441406 3.0429688 L 6.0605469 2.0722656 A 0.50005 0.50005 0 0 0 5.8242188 2 z M 9.5 2 A 0.50004997 0.50004997 0 0 0 9 2.5 L 9 10.5 A 0.50004997 0.50004997 0 0 0 9.5 11 L 14.5 11 A 0.50004997 0.50004997 0 0 0 15 10.5 L 15 2.5 A 0.50004997 0.50004997 0 0 0 14.5 2 L 9.5 2 z M 10 3 L 14 3 L 14 10 L 10 10 L 10 3 z M 2.5 9 C 2.22387 9 2.00003 9.2239 2 9.5 L 2 14.5 C 2.00003 14.7761 2.22387 15 2.5 15 L 10.5 15 C 10.776131 15 10.999972 14.7761 11 14.5 L 11 12 L 10 12 L 10 14 L 3 14 L 3 10 L 8 10 L 8 9 L 2.5 9 z ",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.2466c80e2f41ca63f2b4f1eab54331e7.svg";
export { ForwardRef as ReactComponent };